<template>
    <div :class="isMobile ? 'mobileBox' : 'achievementBox'">
        <!-- 业务分类标签（上方） -->
        <div class="tabs-row" v-if="showTabs && categoryList.length > 0">
            <button v-if="showAllTab" :class="activeTab === -1 ? 'tab-active' : 'tab-btn'" @click="changeTab(-1, '')">全部</button>
            <button :class="activeTab === index ? 'tab-active' : 'tab-btn'" v-for="(item, index) in categoryList" :key="index" @click="changeTab(index, item.title)">{{ item.title }}</button>
        </div>

        <!-- 内容区域 -->
        <div class="content-wrapper">
            <!-- 左侧：行业分类 -->
            <div class="sidebar" v-if="showSidebar && industryList.length > 0">
                <div class="sidebar-title">行业分类</div>
                <button :class="activeIndustry === -1 ? 'industry-active' : 'industry-btn'" @click="changeIndustry(-1, '')">全部</button>
                <button :class="activeIndustry === index ? 'industry-active' : 'industry-btn'" v-for="(item, index) in industryList" :key="index" @click="changeIndustry(index, item)">{{ item }}</button>
            </div>

            <!-- 右侧：项目列表 -->
            <div class="project-list" v-loading="loading" element-loading-text="加载中......">
                <div class="project-card" v-for="(item, index) in achievementList" :key="index" @click="viewDetail(item.id)">
                    <div class="card-left">
                        <img v-if="item.picture" :src="item.picture" alt="" loading="lazy">
                        <div v-else class="date-placeholder">
                            <span class="date-year">{{ item.year }}</span>
                            <span class="date-day">{{ item.day }}</span>
                            <span class="date-month">{{ item.month }}</span>
                        </div>
                    </div>
                    <div class="card-right">
                        <h3 class="card-title">{{ item.title }}</h3>
                        <p class="card-summary" v-if="item.summary">{{ item.summary }}</p>
                        <div class="card-meta">
                            <p v-if="item.investment">项目投资：{{ item.investment }}万元</p>
                            <p v-if="item.serviceScope">服务范围：{{ item.serviceScope }}</p>
                        </div>
                    </div>
                </div>

                <el-empty v-if="!loading && achievementList.length === 0" description="暂无数据"></el-empty>

                <el-pagination
                    v-if="showPagination && total > pageSize"
                    class="pageBox"
                    background
                    @current-change="handleCurrentChange"
                    :current-page.sync="currentPage"
                    :layout="isMobile ? 'prev, pager, next' : 'prev, pager, next, jumper'"
                    :pager-count="isMobile ? 5 : 7"
                    :page-size="pageSize"
                    :total="total">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
const NEW_API_BASE = process.env.VUE_APP_NEW_API_URL || '/prod-api'

// 拼接新接口完整URL，避免被axios实例的baseURL拼接
const newApi = (path) => NEW_API_BASE + path

export default {
    name: 'TypicalAchievement',
    props: {
        businessType: { type: String, default: '' },
        showTabs: { type: Boolean, default: true },
        showAllTab: { type: Boolean, default: false },
        showSidebar: { type: Boolean, default: false },
        showPagination: { type: Boolean, default: true },
        pageSize: { type: Number, default: 9 },
        maxCount: { type: Number, default: 9 }
    },
    data() {
        return {
            isMobile: false,
            activeTab: 0,
            activeIndustry: -1,
            categoryList: [],
            industryList: [],
            achievementList: [],
            currentBusinessType: '',
            currentIndustryType: '',
            currentPage: 1,
            total: 0,
            loading: false
        }
    },
    mounted() {
        this.checkMobile();
        window.addEventListener('resize', this.checkMobile);
        this.getCategories();
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.checkMobile);
    },
    methods: {
        checkMobile() {
            this.isMobile = window.innerWidth <= 768;
        },
        changeTab(index, type) {
            this.activeTab = index;
            this.currentBusinessType = type;
            this.currentPage = 1;
            this.achievementList = [];
            this.getIndustryTypes();
        },
        changeIndustry(index, type) {
            this.activeIndustry = index;
            this.currentIndustryType = type;
            this.currentPage = 1;
            this.achievementList = [];
            this.getAchievements();
        },
        getCategories() {
            if (this.businessType) {
                this.currentBusinessType = this.businessType;
                this.categoryList = [];
                this.getIndustryTypes();
                return;
            }

            this.Request({
                url: newApi('/hzfglSys/open/typical-case/businessTypes'),
                method: 'get',
                baseURL: ''
            }).then((data) => {
                if (data.data && data.data.length > 0) {
                    var sorted = this.sortCategoryList(data.data);
                    this.categoryList = sorted.map(t => ({ title: t }));
                    this.currentBusinessType = this.showAllTab ? '' : sorted[0];
                    this.activeTab = this.showAllTab ? -1 : 0;
                }
                this.getIndustryTypes();
            });
        },
        getIndustryTypes() {
            var params = {};
            if (this.currentBusinessType) {
                params.businessType = this.currentBusinessType;
            }
            this.Request({
                url: newApi('/hzfglSys/open/typical-case/industryTypes'),
                method: 'get',
                data: params,
                baseURL: ''
            }).then((data) => {
                this.industryList = data.data || [];
            }).catch(() => {
                this.industryList = [];
            }).finally(() => {
                this.activeIndustry = -1;
                this.currentIndustryType = '';
                this.getAchievements();
            });
        },
        // 排序：全过程咨询 → 招标采购 → 投资咨询 → 造价咨询 → 管理咨询 → 数智化应用
        sortCategoryList(list) {
            var order = ['全过程咨询', '招标采购', '投资咨询', '造价咨询', '管理咨询', '数智化应用'];
            var sorted = [];
            order.forEach(function(label) {
                var found = list.find(function(item) { return item === label; });
                if (found) sorted.push(found);
            });
            list.forEach(function(item) {
                if (sorted.indexOf(item) === -1) sorted.push(item);
            });
            return sorted;
        },
        getAchievements() {
            this.loading = true;
            const params = {
                pageNum: this.currentPage,
                pageSize: this.showPagination ? this.pageSize : this.maxCount
            };
            if (this.currentBusinessType) {
                params.businessType = this.currentBusinessType;
            }
            if (this.currentIndustryType) {
                params.industryType = this.currentIndustryType;
            }

            this.Request({
                url: newApi('/hzfglSys/open/typical-case/list'),
                method: 'get',
                data: params,
                baseURL: ''
            }).then((data) => {
                if (data.data && data.data.records && data.data.records.length > 0) {
                    this.total = data.data.total;
                    this.achievementList = data.data.records.map(item => {
                        const addTime = item.addTime || '';
                        const dateStr = addTime.split(' ')[0];
                        const parts = dateStr.split('-');
                        const year = parts[0] || '';
                        const day = parts[2] || '';
                        const monthNum = parts[1] || '';
                        const month = monthNum ? monthNum + '月' : '';
                        return {
                            id: item.rowGuid,
                            title: item.projectName,
                            picture: item.attachments && item.attachments.length > 0 ? item.attachments[0].fileUrl : '',
                            summary: item.projectSummary || '',
                            investment: item.projectInvestment != null ? item.projectInvestment : '',
                            serviceScope: item.serviceScope || '',
                            year: year,
                            day: day,
                            month: month
                        };
                    });
                } else {
                    this.achievementList = [];
                    this.total = 0;
                }
            }).finally(() => {
                this.loading = false;
            });
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.getAchievements();
        },
        viewDetail(id) {
            window.open('/aboutUs/TypicalCaseDetail?rowGuid=' + id, '_blank');
        }
    }
}
</script>

<style scoped lang="less">
.achievementBox {
    width: 1200px;
    margin: 0 auto;
    margin-top: 30px;
    padding-bottom: 50px;
}

.mobileBox {
    width: 100%;
    padding: 0 10px;
    margin-top: 20px;
    padding-bottom: 30px;
}

/* 业务分类标签 */
.tabs-row {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    margin-bottom: 20px;
}

.tab-active {
    padding: 8px 20px;
    color: #fff;
    background-color: #247CD6;
    border-radius: 4px;
    border: none;
    margin-right: 12px;
    margin-bottom: 10px;
    cursor: pointer;
    font-size: 14px;
}

.tab-btn {
    padding: 8px 20px;
    color: #333;
    background-color: #F4F4F4;
    border-radius: 4px;
    border: none;
    margin-right: 12px;
    margin-bottom: 10px;
    cursor: pointer;
    font-size: 14px;
    &:hover {
        color: #247CD6;
    }
}

/* 内容区域 */
.content-wrapper {
    display: flex;
}

/* 左侧行业分类 */
.sidebar {
    width: 140px;
    flex-shrink: 0;
    margin-right: 20px;
}

.sidebar-title {
    font-size: 16px;
    font-weight: bold;
    color: #333;
    margin-bottom: 12px;
    padding-left: 4px;
}

.industry-active {
    display: block;
    width: 100%;
    padding: 10px 12px;
    text-align: center;
    border: none;
    background: #247CD6;
    color: #fff;
    cursor: pointer;
    margin-bottom: 6px;
    border-radius: 4px;
    font-size: 13px;
}

.industry-btn {
    display: block;
    width: 100%;
    padding: 10px 12px;
    text-align: center;
    border: none;
    background: #F4F4F4;
    cursor: pointer;
    margin-bottom: 6px;
    border-radius: 4px;
    font-size: 13px;
    color: #333;
    &:hover {
        color: #247CD6;
    }
}

/* 右侧项目列表 */
.project-list {
    flex: 1;
    min-width: 0;
}

/* 项目卡片 */
.project-card {
    display: flex;
    border: 1px solid #E8E8E8;
    border-radius: 8px;
    margin-bottom: 20px;
    overflow: hidden;
    cursor: pointer;
    transition: all 0.3s;
    &:hover {
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        transform: translateY(-2px);
    }
}

.card-left {
    width: 260px;
    height: 200px;
    flex-shrink: 0;
    overflow: hidden;
    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
}

/* 无图片时显示日期 */
.date-placeholder {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: #f5f7fa;
    color: #247CD6;
    position: relative;
    overflow: hidden;
}

.date-placeholder::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: linear-gradient(90deg, #247CD6, #5BA3EC);
}

.date-year {
    font-size: 16px;
    font-weight: 500;
    color: #999;
    letter-spacing: 2px;
    margin-bottom: 4px;
}

.date-day {
    font-size: 52px;
    font-weight: bold;
    line-height: 1.1;
}

.date-month {
    font-size: 14px;
    margin-top: 2px;
    color: #5BA3EC;
}

.card-right {
    flex: 1;
    padding: 20px;
    display: flex;
    flex-direction: column;
    min-width: 0;
}

.card-title {
    font-size: 18px;
    font-weight: bold;
    color: #333;
    margin: 0 0 12px 0;
    line-height: 1.4;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}

.card-summary {
    font-size: 14px;
    color: #666;
    line-height: 1.6;
    margin: 0 0 12px 0;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
}

.card-meta {
    margin-top: auto;
    p {
        font-size: 13px;
        color: #999;
        margin: 4px 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
}

.pageBox {
    text-align: center;
    margin-top: 30px;
    margin-bottom: 20px;
}

/* 移动端适配 */
@media screen and (max-width: 768px) {
    .content-wrapper {
        flex-direction: column;
    }

    .sidebar {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        margin-right: 0;
        margin-bottom: 15px;
    }

    .sidebar-title {
        width: 100%;
    }

    .industry-active, .industry-btn {
        width: auto;
        margin-right: 8px;
    }

    .project-card {
        flex-direction: column;
    }

    .card-left {
        width: 100%;
        height: 180px;
    }

    .card-right {
        padding: 12px;
    }

    .card-title {
        font-size: 16px;
    }
}
</style>
